{
  "version": 1,
  "asset_id": "7d0bb014-bf01-499e-baba-c9cb086a5c32",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/7d0bb014-bf01-499e-baba-c9cb086a5c32/raindrop-dry-debris.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/7d0bb014-bf01-499e-baba-c9cb086a5c32/raindrop-dry-debris.mp4",
  "original_filename": "raindrop-dry-debris.mp4",
  "size": 6971398,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:28Z"
}
